import request from '@/utils/request'
import api from '@/api'
import { arrayObjectSort } from '@/utils'

const state = () => ({})
const getters = {}

const mutations = {}

const actions = {
  SurveyGetDetails(context, params) {
    return new Promise((resolve, reject) => {
      request({
        url: api.SurveyGetDetails + '?random=' + Math.random(),
        method: 'GET',
        params,
      })
        .then(({ Data, Code, Message }) => {
          if (Code === 0) {
            arrayObjectSort(Data.stem, 'Sort')
            arrayObjectSort(Data.option, 'Sort')
            resolve({ Data, Code, Message })
          } else {
            reject({ Data, Code, Message })
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  SurveyGetDetailsV2(context, params) {
    return new Promise((resolve, reject) => {
      request({
        url: api.SurveyGetDetailsV2 + '?random=' + Math.random(),
        method: 'GET',
        params,
      })
        .then(({ Data, Code, Message }) => {
          if (Code === 0) {
            arrayObjectSort(Data.stem, 'Sort')
            if (Data.option && Data.option.length) {
              arrayObjectSort(Data.option, 'Sort')
            }
            resolve({ Data, Code, Message })
          } else {
            reject({ Data, Code, Message })
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  SurveyResultStart(context, params) {
    return request({
      url: api.SurveyResultStart + '?random=' + Math.random(),
      method: 'PUT',
      params,
    })
  },

  SurveyResultComplete(context, params) {
    return request({
      url: api.SurveyResultComplete + '?random=' + Math.random(),
      method: 'POST',
      data: params,
    })
  },

  SurveyAnswerAdd(context, params) {
    return request({
      url: api.SurveyAnswerAdd + '?random=' + Math.random(),
      method: 'PUT',
      data: params,
    })
  },

  SurveyAnswerAnswerList(context, params) {
    return request({
      url: api.SurveyAnswerAnswerList + '?random=' + Math.random(),
      method: 'PUT',
      data: params,
    })
  },
  WorkflowStart(context, params) {
    return request({
      url: api.WorkflowStart + '?random=' + Math.random(),
      method: 'POST',
      data: params,
    })
  },
  WorkflowAdvancedApply(context, params) {
    return request({
      url: api.WorkflowAdvancedApply + '?random=' + Math.random(),
      method: 'POST',
      data: params,
    })
  },
  WorkflowAgreement(context, params) {
    return request({
      url: api.WorkflowAgreement + '?random=' + Math.random(),
      method: 'POST',
      data: params,
    })
  },
  FormQueryFormSurvey(context, params) {
    return request({
      url: api.FormQueryFormSurvey + '?random=' + Math.random(),
      method: 'GET',
      params,
    })
  },
  SurveyResultGetListByUser(context, params) {
    return request({
      url: api.SurveyResultGetListByUser + '?random=' + Math.random(),
      method: 'GET',
      params,
    })
  },
  SurveyResultGetListByUserId(context, params) {
    return request({
      url: api.SurveyResultGetListByUserId,
      method: 'GET',
      params,
    })
  },
  ProductAgreementGet(context, params) {
    return request({
      url: api.ProductAgreementGet + '?random=' + Math.random(),
      method: 'GET',
      params,
    })
  },
  AssessmentGetDetailById(context, params) {
    return request({
      url: api.AssessmentGetDetailById,
      method: 'GET',
      params,
    })
  },
  AssessmentAnswer(context, params) {
    return request({
      url: api.AssessmentAnswer,
      method: 'POST',
      data: params,
    })
  },
  GetUserResult(context, params) {
    return request({
      url: api.GetUserResult,
      method: 'GET',
      params,
    })
  },
  BindFastDealFormByActiveLink(context, params) {
    return request({
      url: api.BindFastDealFormByActiveLink,
      method: 'POST',
      data: params,
    })
  },
  GetByDispatchIds(context, params) {
    return request({
      url: api.GetByDispatchIds,
      method: 'POST',
      data: params,
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
